import React from 'react';
import { Filter, TextInput, List, Datagrid, TextField, Pagination, DisabledInput, Edit, SimpleForm, EditButton } from 'react-admin';


const CountryPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

const CountryFielter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

export const CountryList = (props) => (

    <List {...props} resource="countries" pagination={<CountryPagination />} filters={<CountryFielter />} bulkActionButtons={false}>
        <Datagrid>
            <TextField label="Country ID" source="id" />
            <TextField label="Country" source="country" />
            <EditButton />
        </Datagrid>
    </List>
);

const CountryTitle = (record) => (
  <span>
      {' Edit '} &quot;{
          record.country
      }&quot;
  </span>
);

export const CountryEdit = props => (
  <Edit title={<CountryTitle />} {...props}>
      <SimpleForm>
          <DisabledInput label="Id" source="id" />
          <TextInput label="Country" source="country" />
      </SimpleForm>
  </Edit>
);


// WEBPACK FOOTER //
// ./src/resources/countries.js